import { ConsentType } from '@/enums'
import { HATEOASLink } from './hateoasLink.interface'

export class RequiredConsent {
  constructor(init: Partial<RequiredConsent> = {}) {
    this.type = init.type
    this.title = init.title || ''
    this.documentUrl = init.documentUrl || ''
    this.language = init.language || ''
    this.version = init.version
    this._links = {
      accept: init._links?.accept,
    }
  }

  type?: ConsentType
  title: string
  documentUrl: string
  language: string
  version?: number
  _links: {
    accept?: HATEOASLink
  }
}
